import { AdminDashboard } from "./components/AdminDashboard";
import { PublicProfile } from "./components/PublicProfile";

export function App() {
  const isAdmin = window.location.pathname.startsWith("/admin");

  return isAdmin ? <AdminDashboard /> : <PublicProfile />;
}
